import { createContext } from 'react';
import { createContextualCan } from '@casl/react';
import { defaultAbility } from 'contexts/ability';
import type { AppAbility } from 'contexts/ability';

export const AbilityContext = createContext<AppAbility>(defaultAbility);

export const Can = createContextualCan(AbilityContext.Consumer);
